import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "required"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = ["type", "disabled", "placeholder"]

import IconAlertCircle from '@/design-system/assets/icons/IconAlertCircle.vue'
import IconCalendar from '@/design-system/assets/icons/IconCalendar.vue'
import IconCheckCircle from '@/design-system/assets/icons/IconCheckCircle.vue'
import IconSearch from '@/design-system/assets/icons/IconSearch.vue'
import IconX from '@/design-system/assets/icons/IconX.vue'
import { toRefs, ref, watch, onMounted } from 'vue'
import TooltipStandardV2 from '../atoms/TooltipStandardV2.vue'
import IconInfoCircle from '../assets/icons/IconInfoCircle.vue'

interface EMITS {
  (e: 'emitInput', inputValue: string | number): void
  (e: 'emitBlur')
  (e: 'emitClearInput')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TextFieldStandard',
  props: {
    clearInput: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    helpText: { default: '' },
    hideIconX: { type: Boolean, default: false },
    infoText: { default: '' },
    label: { default: '' },
    numberValue: { default: 0 },
    placeHolderText: { default: '' },
    prefilledText: { default: '' },
    required: { type: Boolean, default: false },
    searchInput: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    type: { default: 'text' },
    focus: { type: Boolean, default: false }
  },
  emits: ["emitInput", "emitBlur", "emitClearInput"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { clearInput } = toRefs(props)
const emits = __emit
const inputRef = ref<HTMLInputElement | null>(null)
const inputValue = ref<string | number>('')
const prefilledText = ref<string>(props.prefilledText)
const showIconXValue = ref<string>('')

watch(
  () => props.numberValue,
  (newVal) => {
    inputValue.value = newVal
  }
)
function clearInputvalue() {
  showIconXValue.value = ''
  emits('emitClearInput')
  if (!props.prefilledText.length) inputValue.value = ''
  inputRef.value?.focus()
}
function emitInputValue() {
  emits('emitInput', inputValue.value)
}
function hideIconX() {
  showIconXValue.value = ''
}
function openCalendar() {
  if (!props.disabled && inputRef.value) inputRef.value.showPicker()
}
function showIconX() {
  showIconXValue.value = 'show'
}
watch(clearInput, (newVal) => {
  if (newVal == true) {
    clearInputvalue()
    showIconXValue.value = ''
    inputRef.value?.blur()
    emitInputValue()
  }
})
watch(inputValue, (newVal) => {
  if (typeof newVal === 'string' && newVal.length >= 1 && !props.hideIconX) showIconX()
  else hideIconX()
})
if (prefilledText.value?.length) inputValue.value = prefilledText.value
watch(prefilledText, (newVal) => {
  if (newVal?.length) inputValue.value = newVal
})
onMounted(() => {
  if (prefilledText.value?.length) inputValue.value = prefilledText.value
  if (props.type === 'number' && props.numberValue !== undefined)
    inputValue.value = props.numberValue

  if (props.focus) inputRef.value?.focus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-field-standard-box", { 'text-field-standard-box__search': _ctx.searchInput }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-field-standard-box__label", { 'text-field-standard-box__label__disabled': _ctx.disabled }])
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
        : _createCommentVNode("", true),
      (_ctx.infoText)
        ? (_openBlock(), _createBlock(TooltipStandardV2, {
            key: 1,
            text: _ctx.infoText,
            arrowPosition: 'bottom-center',
            "vertical-offset": 2
          }, {
            default: _withCtx(() => [
              _createVNode(IconInfoCircle)
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.searchInput)
        ? (_openBlock(), _createBlock(IconSearch, {
            key: 0,
            class: "input-icon-left"
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        type: _ctx.type,
        class: _normalizeClass(["text-field-standard", {
          'text-field-standard__date': _ctx.type === 'date',
          'text-field-standard__error': _ctx.error,
          'text-field-standard__success': _ctx.success,
          'text-field-standard__disabled': _ctx.disabled,
          'text-field-standard__search': _ctx.searchInput
        }]),
        disabled: _ctx.disabled,
        placeholder: _ctx.placeHolderText,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (emits('emitBlur'))),
        onInput: emitInputValue
      }, null, 42, _hoisted_3), [
        [_vModelDynamic, inputValue.value]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["input-icon", { 'input-icon__error': _ctx.error, 'input-icon__success': _ctx.success }])
      }, [
        (_ctx.error)
          ? (_openBlock(), _createBlock(IconAlertCircle, {
              key: 0,
              class: "input-icon__icon-error"
            }))
          : _createCommentVNode("", true),
        (_ctx.type === 'date')
          ? (_openBlock(), _createBlock(IconCalendar, {
              key: 1,
              class: _normalizeClass(["input-icon__icon-date", { 'input-icon__icon-date__disabled': _ctx.disabled }]),
              role: "button",
              tabindex: _ctx.disabled ? -1 : 0,
              onClick: openCalendar,
              onKeydown: [
                _withKeys(openCalendar, ["enter"]),
                _withKeys(openCalendar, ["space"])
              ]
            }, null, 8, ["class", "tabindex"]))
          : _createCommentVNode("", true),
        (_ctx.success)
          ? (_openBlock(), _createBlock(IconCheckCircle, {
              key: 2,
              class: "input-icon__icon-success"
            }))
          : _createCommentVNode("", true),
        (showIconXValue.value !== '' && !_ctx.disabled)
          ? (_openBlock(), _createBlock(IconX, {
              key: 3,
              class: "input-icon__icon-x",
              role: "button",
              tabindex: "0",
              onClick: clearInputvalue,
              onKeydown: [
                _withKeys(clearInputvalue, ["enter"]),
                _withKeys(clearInputvalue, ["space"])
              ]
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["text-field-standard-box__help-text", {
        'text-field-standard-box__help-text__disabled': _ctx.disabled,
        'text-field-standard-box__help-text__error': _ctx.error
      }])
    }, _toDisplayString(_ctx.error ? _ctx.errorMessage : _ctx.helpText), 3)
  ], 2))
}
}

})